// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emoji {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.emoji-btn {\n  width: 55px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.emoji-mart-category-label {\n  display: none;\n}\n.emoji-mart-category .emoji-mart-emoji span {\n  width: 32px !important;\n  height: 32px !important;\n}\n", ""]);
// Exports
module.exports = exports;
